"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobQueueInOrder = void 0;
class JobQueueInOrder {
    constructor(uniqueJobId = false, processJob) {
        this.uniqueJobId = uniqueJobId;
        this.queue = [];
        this.isProcessing = false;
        this.processJob = processJob;
    }
    addJob(job) {
        const jobExists = this.uniqueJobId
            ? this.queue.some((existingJob) => existingJob.id === job.id)
            : false;
        if (!jobExists) {
            this.queue.push(job);
            this.processQueue();
        }
        else {
            console.log(`Job with ID ${job.id} already exists in the queue and will not be added again.`);
        }
    }
    processQueue() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isProcessing) {
                return;
            }
            this.isProcessing = true;
            while (this.queue.length > 0) {
                const job = this.queue.shift();
                if (job) {
                    yield this.processJob(job).catch((e) => {
                        console.error(`Error processing job with ID ${job.id}:`, e.message);
                    });
                }
            }
            this.isProcessing = false;
        });
    }
}
exports.JobQueueInOrder = JobQueueInOrder;
//# sourceMappingURL=queue.js.map